declare module '@mui/material/ButtonBase' {
  interface ButtonBasePropsVariantOverrides {}
}

const ButtonBaseTheme = {
  components: {},
};

export default ButtonBaseTheme;
